exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.lien-panel-enter-active,\n.lien-panel-leave-active {\n  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n.lien-panel-enter-from {\n  transform: translateX(100%);\n}\n.lien-panel-enter-to {\n  transform: translateX(0);\n}\n.lien-panel-leave-from {\n  transform: translateX(0);\n}\n.lien-panel-leave-to {\n  transform: translateX(100%);\n}\n", ""]);

// exports
